import { PropertyStatusBadgeMemo } from '@/components/property/PropertyStatusBadge';
import { ArrowLeft, MapPin, AlertCircle } from 'lucide-react';
import type { IPropertyDetailHeaderProps } from '@/@types/property';

export const PropertyDetailHeader = ({
  property,
  latestVideo,
  hasCompletedVideo,
  onBack,
  formatPrice,
}: IPropertyDetailHeaderProps) => {
  const isFailed = property.status === 'failed' || latestVideo?.status === 'failed';

  return (
    <div className="mb-6">
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 mb-6"
      >
        <ArrowLeft className="h-4 w-4" />
        <span>Back to {hasCompletedVideo ? 'Ready' : 'Draft'}</span>
      </button>

      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
            {property.title}
          </h1>
          {property.city && (
            <div className="flex items-center gap-1.5 text-gray-500 dark:text-gray-400">
              <MapPin className="h-4 w-4" />
              <span>
                {property.address ? `${property.address}, ` : ''}
                {property.city}
              </span>
            </div>
          )}
        </div>
        {property.price && (
          <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            {formatPrice(property.price, property.currency)}
          </div>
        )}
      </div>

      <div className="mt-4">
        <PropertyStatusBadgeMemo
          propertyStatus={property.status}
          videoStatus={latestVideo?.status}
          errorMessage={property.errorMessage || latestVideo?.errorMessage}
        />
      </div>

      {isFailed && (
        <div className="mt-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-red-800 dark:text-red-200">
                {property.status === 'failed'
                  ? 'Property processing failed'
                  : 'Video generation failed'}
              </p>
              <p className="text-sm text-red-600 dark:text-red-300 mt-1">
                {property.errorMessage || latestVideo?.errorMessage || 'An unknown error occurred'}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
